import React, { Component } from 'react';
import './NavLink.css';

class NavLink extends Component {
	render() {
		return (
			<p className="nav-link" onClick={() => this.props.changeLocation(`/dashboard/${this.props.prod}`)}>{this.props.prod}</p>
			)
	}
}

export default NavLink;


// WEBPACK FOOTER //
// ./src/components/Nav/NavLink/NavLink.js